import '../connection';
import axios from 'axios';
export class Base {
    constructor(connection) {
        this.connection = connection;
    }
    async get(url, params) {
        const { data, headers, status } = await axios.get(this.connection.baseUrl + url, { params: params });
        return {
            data,
            headers,
            status,
        };
    }
    async post(url, params) {
        const { data, headers, status } = await axios.post(this.connection.baseUrl + url, params, {
            headers: {
                magic: this.connection.hash,
            },
        });
        return {
            data,
            headers,
            status,
        };
    }
    async put(url, params) {
        const { data, headers, status } = await axios.put(this.connection.baseUrl + url, params);
        return {
            data,
            headers,
            status,
        };
    }
}
//# sourceMappingURL=base.js.map